import { Avatar, Container, styled } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import SignUpForm from "@stories/organisms/SignUpForm/SignUpForm";
import { SubTitle } from "@stories/atoms/SubTitle/SubTitle";

const StyledRoot = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "50vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

const StyledAvatarBox = styled("div")(({ theme }) => ({
  marginBottom: "100",
  alignItems: "center",
  margin: "auto",
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  bgcolor: `${theme.palette.primary.main} !important`,
  marginBottom: "20px",
}));

export const SignUp = () => {
  return (
    <>
      <StyledRoot>
        <Container maxWidth="sm">
          <StyledContent>
            <StyledAvatarBox>
              <StyledAvatar>
                <LockOutlinedIcon />
              </StyledAvatar>
            </StyledAvatarBox>
            <SubTitle title={"Sign up to Social Pro"} />
            <SignUpForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
};
